<app-layout *ngIf="!!(activeIdentity$ | async)"></app-layout>

<!-- auxiliary outlet targeted by fullscreen security components e.g. sign-in -->
<router-outlet name="top"></router-outlet>
